import { ScanOutlined } from '@ant-design/icons'
import { NavLink } from 'react-router-dom'
import { useLogin } from '@api/login/state'
import { ToolTip } from '@ui/index'
import { isOcrRoot } from './region'

export const OcrSettingsLink = ({className, activeClassName}: {className: string; activeClassName: string}) => {
    const loginName = useLogin(state => state.profile.loginName)
    const authorized = useLogin(state => state.isAuthorized)
    if (!authorized || !isOcrRoot(loginName)) return null
    return <ToolTip placement='right' title='OCR — обучение модели'>
        <NavLink to='/lk/ocr' aria-label='OCR — обучение модели' className={({isActive}) => isActive ? `${className} ${activeClassName}` : className}>
            <ScanOutlined style={{fontSize: 20}} aria-hidden='true' />
        </NavLink>
    </ToolTip>
}
